import React, { useEffect, useState, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { createSelector } from 'reselect';
import { CONTEXT } from '../config';
import { cacheKeys, education } from '../constants/storageKeys';
import styles from './User.module.less';
import { imgLocalUrl } from '../utils/utils';
import { PCStoreJsBridge } from '../nativeapi';
// import { updateUserInfo } from '../actions/user';
import { useHistory, useLocation } from 'react-router-dom';
import { logging } from '../actions/log';
import { setIframeVisible } from '../actions/layout';
import { SHOP_ORDER_LIST_65 } from '../config';

const selectUserInfo = createSelector(
  state => state.user,
  user => user.userInfo,
);

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);
const selectTopImgVideoVisible = createSelector(
  state => state.layout,
  layout => layout.topImgVideo,
);

export default function User() {
  const history = useHistory();
  const dispatch = useDispatch();
  const userInfo = useSelector(selectUserInfo);
  const logInfoData = useSelector(selectLogInfo);
  const [loginStatus, setLoginStatus] = useState(null);
  const [isLogoutting, setIsLogoutting] = useState(false);
  const topImgVideo = useSelector(selectTopImgVideoVisible); // 头部图片视频

  /**
   * 第一次进入系统，首先判断用户登录login_status是否正常
   * 正常，就去刷新用户登录信息。
   * 不正常，就直接调用退出登录。
   */
  useEffect(() => {
    const login_status = window.CallNativeMethod('get_login_status');
    setLoginStatus(login_status);
    if (login_status === '1') {
      // 刷新用户登录信息
      window.CallNativeMethod('refresh_account_info');
    } else {
      // window.CallNativeMethod('logout');
    }
  }, [dispatch]);

  /**
   * 检测到用户信息userInfo发生变化时
   * 首先再次获取用户登录状态，登录了则：
   * 1. 讲userInfo保存到localStorage
   * 2. 获取userToken并且保存到localStorage
   */
  useEffect(() => {
    setIsLogoutting(false);
    // 获取并存下登录状态
    const login_status = window.CallNativeMethod('get_login_status');
    setLoginStatus(login_status);
    if (login_status === '1' && userInfo.st) {
      localStorage.setItem(cacheKeys.USER_INFO, JSON.stringify(userInfo));
      // 去获取userToken
      PCStoreJsBridge.getUserTokenInfo().then(res => {
        localStorage.setItem(cacheKeys.X_LESYNC_TOKEN, res ? res[cacheKeys.X_LESYNC_TOKEN] : '');
      });
    }
  }, [userInfo]);

  const handleLogin = useCallback(() => {
    window.CallNativeMethod('logout');
    window.CallNativeMethod('login');
    // 点击 登录
    dispatch(
      logging({
        category: 'C',
        action: 'Login',
        label: '',
        param2: {
          source: 'HomePage',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
        },
      }),
    );
  }, [dispatch, logInfoData]);

  const handleLogout = useCallback(() => {
    setIsLogoutting(true);
    if (isLogoutting === false) {
      window.CallNativeMethod('logout');
      // 退出登录的时候清除ltoken
      localStorage.setItem(cacheKeys.X_LESYNC_TOKEN, '');
      // 点击 登录
      dispatch(
        logging({
          category: 'C',
          action: 'Logout',
          label: '',
          param2: {
            source: 'HomePage',
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
          },
        }),
      );
    }
  }, [isLogoutting]);

  const handleShowOrder = useCallback(() => {
    // dispatch(
    //   setIframeVisible({
    //     visible: true,
    //     url: SHOP_ORDER_LIST_65,
    //     source: 'HomePage',
    //   }),
    // );
    history.push(`${CONTEXT}/ordercenter`);
  }, []);

  const handleUserInfo = useCallback(() => {
    // 点击 会员中心
    dispatch(
      logging({
        category: 'C',
        action: 'User_Info',
        label: '',
        param2: {
          source: 'HomePage',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
        },
      }),
    );
    window.open(
      `https://guanjia.lenovo.com.cn/jump.html?ts=${userInfo.st}&tk=daef3cfe-9d6e-4647-a46d-8be19a47af4b&newurl=https%3A%2F%2Fi.lenovo.com.cn%2FmemberInfo%2Fv2%2Fcenter.jhtml%3Fsts%3Ddaef3cfe-9d6e-4647-a46d-8be19a47af4b`,
    );
  }, [userInfo]);

  return (
    <div
      className={
        topImgVideo && topImgVideo.visible && !topImgVideo.isScrolled
          ? styles.user_white
          : styles.user
      }
    >
      {isLogoutting === true || loginStatus !== '1' || !userInfo.st ? (
        <div className="login">
          <i
            className="icon"
            onClick={() => {
              handleLogin();
            }}
          />
          <span
            className="tit"
            onClick={() => {
              handleLogin();
            }}
          >
            登录
          </span>
          <span className="line" />
        </div>
      ) : (
        <div className="user_login">
          {userInfo.headimgurl ? (
            <img
              className="user_headimg"
              src={
                userInfo.headimgurl.indexOf('http') > -1
                  ? userInfo.headimgurl
                  : imgLocalUrl(userInfo.headimgurl)
              }
              alt=""
            />
          ) : (
            <i className="icon" />
          )}
          <span className="user_name">
            {isLogoutting
              ? '退出中...'
              : userInfo.lidNickName ||
                userInfo.sensitiveNickName ||
                userInfo.uname ||
                userInfo.uName}
          </span>
          <span className="line" />
          <div className="user_opt">
            <div
              className="user_opt_item"
              onClick={() => {
                handleUserInfo();
              }}
            >
              用户信息
            </div>
            {/* <div
              className="user_opt_item"
              onClick={() => {
                handleShowOrder();
              }}
            >
              订单中心
            </div> */}
            <div
              className="user_opt_item"
              onClick={() => {
                handleLogout();
              }}
            >
              退出账号
            </div>
          </div>
        </div>
      )}
      <div className="logout" />
    </div>
  );
}
